import { PARTICIPANT_COPY_TEXTS } from './PARTICIPANT_COPY_TEXTS.js';
const BY_KEY = new Map(PARTICIPANT_COPY_TEXTS.map((text) => [text.key, text]));
/** The text a key names, or undefined for a key that is none. */
export function participantCopyText(key) {
    return BY_KEY.get(key);
}
/** Whether a string is the key of a text. */
export function isParticipantCopyKey(key) {
    return BY_KEY.has(key);
}
//# sourceMappingURL=lookupParticipantCopyText.js.map